/** '보기' 드롭다운 선택지 (05 업체 · 06 거래처 정보 · 07 처방 등록 현황) */
export const PAGE_SIZE_OPTIONS = [25, 50, 100] as const;

/**
 * '보기' 드롭다운 기본값 — Figma "보기: 25개".
 * 서버 기본값(@PageableDefault size 20)과 달라 size 를 항상 보낸다.
 */
export const DEFAULT_VIEW_PAGE_SIZE = 25;
